import { computed } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { flexGapValues, flexWrapValues } from './constants'

import type { FlexProps } from './flex'
import type { CSSProperties, StyleValue } from 'vue'

function isPresetGap(gap: unknown): gap is (typeof flexGapValues)[number] {
  return flexGapValues.includes(gap as (typeof flexGapValues)[number])
}

export function useFlex(props: FlexProps) {
  const ns = useNamespace('flex')
  const prefix = computed(() => ns.b())

  const classes = computed(() => {
    const { wrap, justify, align, gap } = props

    return [
      prefix.value,
      props.class,
      props.vertical && `${prefix.value}-vertical`,
      wrap === true && `${prefix.value}-wrap`,
      wrap === false && `${prefix.value}-nowrap`,
      wrap !== undefined &&
        wrap !== 'nowrap' &&
        wrap !== true &&
        wrap !== false &&
        flexWrapValues.includes(wrap as (typeof flexWrapValues)[number]) &&
        `${prefix.value}-wrap-${wrap}`,
      justify && justify !== 'normal' && `${prefix.value}-justify-${justify}`,
      align && align !== 'normal' && `${prefix.value}-align-${align}`,
      gap !== undefined && isPresetGap(gap) && `${prefix.value}-gap-${gap}`,
    ]
  })

  const containerStyle = computed<StyleValue>(() => {
    const style: CSSProperties = {}

    if (props.flex !== undefined) {
      style.flex = props.flex as CSSProperties['flex']
    }

    if (props.gap !== undefined && !isPresetGap(props.gap)) {
      style.gap =
        typeof props.gap === 'number' ? `${props.gap}px` : (props.gap as string)
    }

    if (!props.style) {
      return style
    }

    return [style, props.style]
  })

  return {
    classes,
    containerStyle,
  }
}
